import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-approval-warning-modal',
  templateUrl: './approval-warning-modal.component.html',
  styleUrl: './approval-warning-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ApprovalWarningModalComponent implements OnInit {
  displayItinerary = false;

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService
  ) {}

  async closeModal(userOk: boolean): Promise<void> {
    this.activeModal.close(userOk);
  }

  ngOnInit(): void {
    this.displayItinerary = this.userService.isBasketReplacementUserFavouriteSet();
  }
}
LightningModalTypes.ApprovalWarningModalComponent.component = ApprovalWarningModalComponent;
